import styled from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.black};
`

export const TitleLink = styled(LinkBase)`
    text-decoration: none;
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    display: flex;
    flex-direction: column;
    max-width: 370px;

    @media ${(props) => props.theme.query.mobile} {
        margin: 0 auto;
    }

    ${(props) => props.theme.typo.bodyS}
    transition: 0.3s ease-in-out;
    opacity: 1;

    svg {
        margin-right: 9px;
        vertical-align: middle;
    }

    &:hover {
        ${Title} {
            opacity: 0.7;
        }
    }

    ${(props) =>
        props.$mode === 'Dark'
            ? `
            color: ${props.theme.color.g100};

            svg {
                path {
                    fill: ${props.theme.color.g100};
                }
            }
            ${Title} {
                color: ${props.theme.color.g100};
            }
        `
            : ``};
`

export const ImageWrapper = styled.div`
    border-radius: 10px;
    overflow: hidden;
    & > div {
        transition: all 0.3s;
        width: 100%;
        height: auto;
        transform: scale(1);

        &:hover {
            transform: scale(1.1);
        }
    }
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyM}
    color: ${(props) => props.theme.color.g500};
    margin-top: 5px;
    line-height: 180%;
`
